<template>

    <div>
        <!--相簿-->
     <template v-if="'/location0112' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data01[1].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>


     <template v-if="'/location0113' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data01[3].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0122' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data01[5].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>  
     </template>

     <template v-if="'/location0131' === this.$route.path ">         
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data01[8].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0141' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data01[10].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>
     <template v-if="'/location0151' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data01[11].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>
     <template v-if="'/location0161' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data01[12].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0171' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data01[13].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0181' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data01[14].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0221' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data02[2].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0231' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data02[3].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0221' === this.$route.path || '/location02' === this.$route.path">
            <ul class="album-list" id="photo0241">
                <li  v-for="(photo) in this.data02[4].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0221' === this.$route.path || '/location02' === this.$route.path ">
            <ul class="album-list " id="photo0251">
                <li  v-for="(photo) in this.data02[5].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0221' === this.$route.path || '/location02' === this.$route.path ">
            <ul class="album-list" id="photo0261">
                <li  v-for="(photo) in this.data02[6].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location03' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data03[0].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0411' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data04[1].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location0412' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data04[2].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

     <template v-if="'/location05' === this.$route.path ">
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data05[0].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
     </template>

       
    

            
    </div>



                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
</template>




<script>

import $ from 'jquery';
import * as PANOLENS from 'panolens'

    export default {
        data() {
            return {

                
            };
        },
         watch: {

         },
        methods: {

            // 圖片
            PicturePath(id) {
                if( id === null  )
                {
                    return `./default.png`; 
                }
                else 
                {
                    return `./images/${id}`;
                }
            },

        },
        mounted: function () {
           

        },

    }
</script>